import {
  InfiniteList,
} from 'react-admin';
import CatalogListToolbar from './CatalogListToolbar';
import CatalogDataTable from './CatalogDataTable';
import { useTitle } from '@src/hooks/useTitle';
import { getCurrentPartner } from '@src/providers/dataProvider/shared';

const CatalogItemList = () => {
  const { title } = useTitle('Catalog');
  // react-admin persists list filter/sort/pagination state in localStorage keyed
  // only by resource name, which survives the full page reload the partner
  // switcher does - scope the key by partner so switching partners doesn't
  // carry over the previous partner's filter selections.
  // getCurrentPartner() (not requirePartner()) because this runs at render time -
  // a missing partner should surface as the data provider's error toast, not a
  // thrown error that crashes past react-admin's layout error boundary.
  const partnerCode = getCurrentPartner()?.code;

  return (
    <InfiniteList
      perPage={25}
      sort={{ field: 'title', order: 'ASC' }}
      title={title}
      actions={false}
      storeKey={`catalog-items.${partnerCode}.listParams`}
      sx={{
        '& .RaList-content': {
          paddingTop: 0,
        },
        '& .RaList-main': {
          marginTop: 0,
        }
      }}
    >
      <CatalogListToolbar />
      <CatalogDataTable />
    </InfiniteList>
  );
};

export default CatalogItemList;
